
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/aabne-skisteder",
      function () {
        return require("private-next-pages/[region]/aabne-skisteder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/aabne-skisteder"])
      });
    }
  